import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import {Icon, AbstractFormComponent} from 'front-onceforall-core';
import {requiredValidator} from 'front-onceforall-core/dist/utils/validators';

import userCaseService from '../../../services/userCase/UserCaseService';
import {addError, addSuccess} from '../../../actions/snackbars';
import {captureError} from '../../../utils/log';

export class ContactForm extends AbstractFormComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      types: []
    };
  }

  componentDidMount() {
    this.getContactTypes();
  }

  getFormData() {
    return {
      type: '',
      content: ''
    };
  }

  getFormValidators() {
    return {
      type: requiredValidator,
      content: requiredValidator
    };
  }

  getContactTypes = () => {
    userCaseService.getUserRequestTypes()
      .then(types => {
        this.setState(state => ({
          types,
          loading: false,
          formData: {
            ...state.formData,
            type: types.find(type => type.value === this.props.selectedRequestType)?.value || state.formData.type
          }
        }));
      })
      .catch(() => {
        this.setState({
          types: [],
          loading: false
        });
        this.props.actions.addError(<Translate value="error.generic"/>);
        this.props.onClose();
      });
  };

  handleSubmitCallback() {
    const data = {
      ...this.state.formData,
      organisationId: this.props.organisationId
    };

    userCaseService.createUserRequest(data)
      .then(() => {
        this.props.actions.addSuccess(<Translate value="contact.creationSuccess"/>);
        setTimeout(this.props.onClose, 0);
      })
      .catch(error => {
        captureError('createUserRequest', error);
        this.props.actions.addError(<Translate value="error.generic"/>);
      })
      .finally(() => {
        this.setState({
          submitting: false,
          loading: false
        });
      });
  }

  render() {
    const types = this.state.types.map(type => (
      <MenuItem
        key={type.value}
        value={type.value}
      >
        <Translate value={`contact.types.${type.value}`}/>
      </MenuItem>
    ));

    return (
      <form
        onSubmit={this.handleSubmit}
        style={{position: 'relative'}}
      >
        {this.state.loading && <div className="loading-overlay"/>}
        <h2><Translate value="contact.title"/></h2>
        <TextField
          data-id="type"
          select
          label={this.getFieldLabel('contact.type', true)}
          helperText={this.helperText('type')}
          error={this.isOnError('type')}
          name="type"
          value={this.state.formData.type}
          onChange={this.handleChange('type')}
          disabled={this.state.loading}
        >
          {types}
        </TextField>
        <TextField
          data-id="content"
          multiline
          rows={15}
          rowsMax={20}
          label={this.getFieldLabel('contact.content', true)}
          helperText={this.helperText('content')}
          error={this.isOnError('content')}
          name="content"
          value={this.state.formData.content}
          onChange={this.handleChange('content')}
          disabled={this.state.loading}
        />
        <div className="actions col-12 inline-container space-between">
          <button
            type="button"
            className="large secondary inline-container"
            onClick={this.props.onClose}
            data-id="cancel"
          >
            <Icon icon="go-back"/>
            <Translate value="action.cancel"/>
          </button>
          <button
            className="large primary inline-container"
            type="submit"
            disabled={this.state.submitting || this.state.loading}
          >
            <Icon icon={this.state.submitting || this.state.loading ? 'loader' : 'check'}/>
            <Translate value="action.continue"/>
          </button>
        </div>
        <hr/>
      </form>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({addError, addSuccess}, dispatch)
});

ContactForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    addError: PropTypes.func.isRequired,
    addSuccess: PropTypes.func.isRequired
  }).isRequired,
  organisationId: PropTypes.number.isRequired,
  selectedRequestType: PropTypes.string
};

export default connect(null, mapDispatchToProps)(ContactForm);
